import { render, staticRenderFns } from "./UserCentral.vue?vue&type=template&id=0c36f6ae&scoped=true&"
import script from "./UserCentral.vue?vue&type=script&lang=js&"
export * from "./UserCentral.vue?vue&type=script&lang=js&"
import style0 from "./UserCentral.vue?vue&type=style&index=0&id=0c36f6ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c36f6ae",
  null
  
)

export default component.exports